export const TOKEN_NAME = 'IDONK';

export const MB = 2;

export const COMMUNITY_PAGINATION_LENGTH = 18;

export const BAD_INDEX = 7;

export const PDFs_OK = false;

export const barred = ['.pdf', '.zar', '.zip', '.rar'];

export const PDF_ERROR = (bar) => `We are on Free account and it does not support ${bar} files We hope to upgrade and serve you better`;

export const etherscanApiKey = "U6SA62AJSXZFUW7FRA6XA8MN46HZ3RJFI3";

export const ERC20_ADDRESS = "0xf43980d57ae6d79d56f069cdaa351395610381ba";

export const CONTRACT_ADDRESS = "0xf43980d57ae6d79d56f069cdaa351395610381ba";

export const SERVER_URL = 'https://stylus-web3-hackathon-backend.onrender.com';

export const FRONTEND_URL = 'https://idonk.netlify.app';

// can be updated to any number on production launch
export const REWARDS_THRESHOLD = 2;

export const COMMUNITY_TOPICS = ['Block Chain & Web3', 'Music', 'Politics', 'Programming', 'Arts and Culture', 'Education', 'Science and tech'];

export const POST_TAGS = [
    'Block Chain & Web3', 'Music', 'Politics', 'Programming', 'Arts and Culture', 'Education', 'Science and tech'
];

export const USER_INTERESTS = ['Block Chain & Web3', 'Music', 'Politics', 'Programming', 'Arts and Culture', 'Education', 'Science and tech', 'Sports'];
